import React from "react";
import "./style.scss";
import { Table } from "react-bootstrap";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import { useNavigate } from "react-router-dom";
import { BenefitTypeArray } from "./arrayData";

const BenefitsandDeduction = ({
  title,
  benefitsData = [],
  deductionData = [],
  selectedEmployee,
  groupId,
}) => {
  const isBenefits = title === "benefits";
  const navigate = useNavigate();

  const content = {
    heading: isBenefits ? "All Benefits" : "Deduction",
    description: isBenefits
      ? "These are the benefits provided by your company and applied to your paycheck."
      : "The following deductions have been set up by your company for you. The deduction amount is withheld post-tax from your net pay.",
    buttonText: isBenefits ? "Add Benefits" : "Add Deduction",
    headers: isBenefits
      ? [
          "S.No",
          "Benefit Name",
          "Benefits Type",
          "Employee’s Deduction",
          "Company Contribution",
        ]
      : [
          "S.No",
          "Deduction Name",
          "Deduction Type",
          "Type/Description",
          "Amount",
        ],
    rowData: isBenefits
      ? (benefitsData || []).filter((item) => item.active)
      : (deductionData || []).filter((item) => item.active),
  };
  const renderCell = (value) => {
    return value !== null && value !== undefined && value !== "" ? value : "-";
  };
  const renderGarnishmentType = (value) => {
    if (value !== null && value !== undefined && value !== "") {
      return value
        .replace(/_/g, " ")
        .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
    }
    return "Custom";
  };

  const renderCurrency = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? `$${value} ${isBenefits ? "" : "Per Paycheck"}`
      : "-";
  };
  const handleCreateFlow = () => {
    navigate(
      `/iframe?type=${isBenefits ? "benefits" : "deductions"}&from=profile`,
      {
        state: { selectedEmployee },
      }
    );
  };
  const renderWithTooltip = (text) => {
    if (!text || text === "-") return "-";
    return text.length > 15 ? (
      <Tooltip
        placement="top"
        overlay={<div style={{ wordBreak: "break-word" }}>{text}</div>}
        overlayClassName="timeoff-calender-tooltip"
      >
        <div>{text.substring(0, 15)}...</div>
      </Tooltip>
    ) : (
      text
    );
  };
  const guhrooUserDetails = JSON.parse(
    localStorage.getItem("guhroo_user_details")
  );
  return (
    <>
      <div className="d-flex justify-content-between flex-column flex-sm-row flex-md-row">
        <div className="benefits-title-wrapper">
          <h5>{content.heading}</h5>
          <p>{content.description}</p>
        </div>
        {guhrooUserDetails.user_type === "Employee" ||
        guhrooUserDetails.user_type === "Manager" ? null : (
          <button className="add-btn-wrapper" onClick={handleCreateFlow}>
            {content.buttonText}
          </button>
        )}
      </div>
      <div className="table_mobile_scroll">
        <Table className="header_bg_table benefits-deduction-table">
          <thead>
            <tr>
              {content.headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {content.rowData.length > 0 ? (
              content.rowData.map((data, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  {isBenefits ? (
                    <>
                      <td>{renderWithTooltip(renderCell(data.description))}</td>{" "}
                      <td>
                        {renderCell(
                          BenefitTypeArray.find(
                            (benefit) =>
                              benefit.benefit_type === data.benefit_type
                          ).name
                        )}
                      </td>
                      <td>
                        {data.deduct_as_percentage
                          ? data.employee_deduction + "%"
                          : renderCurrency(data.employee_deduction)}
                      </td>{" "}
                      <td>
                        {data?.contribute_as_percentage
                          ? data.company_contribution + "%"
                          : renderCurrency(data.company_contribution)}
                      </td>{" "}
                    </>
                  ) : (
                    <>
                      <td style={{ width: "18%" }}>
                        {renderWithTooltip(renderCell(data.description))}
                      </td>{" "}
                      <td>{renderGarnishmentType(data.garnishment_type)}</td>
                      <td style={{ width: "18%" }}>
                        {renderWithTooltip(renderCell(data.description))}
                      </td>{" "}
                      <td>
                        {data.deduct_as_percentage
                          ? data.amount + "%"
                          : renderCurrency(data.amount)}
                      </td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={content.headers.length}
                  style={{ textAlign: "center" }}
                >
                  {isBenefits
                    ? "No Benefits added yet"
                    : "No Deductions added yet"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default BenefitsandDeduction;
